import React from "react";
import $ from 'jquery';
import jQuery from 'jquery';
import Loader from "./Loader";
import Footer from "./Footer";
import ReactMarkdown from 'react-markdown';

class Contact extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: true,
            isSent: false,
            isSubmitting: false,
            contact_description: ''
        };
    }

    // ... (fetchUtils and jsSetup omitted for brevity, but I need to keep them if I'm replacing the whole range)
    // Actually I'll target the handleSubmit section.



    fetchUtils() {
        let url = 'https://api.jamescosmin.com/contact-description/';
        fetch(url)
            .then(response => response.json())
            .then(response => {
                // console.log('data : ', response);
                this.setState({
                    contact_description: response.description
                })
                // console.log(typeof this.state.photos)
            }).catch(e => {
                // console.log('ERROR : ', e)
            })
    }

    jsSetup() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        var week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        var dayName = week[new Date().getDay()];
        today = mm + '-' + dd + '-' + yyyy + ' ' + dayName;
        $("#date_count").text(today);

        function startTime() {
            var today = new Date();
            var h = today.getHours();
            var m = today.getMinutes();
            var s = today.getSeconds();
            m = checkTime(m);
            s = checkTime(s);
            $('#time_count').text(h + ":" + m + ":" + s);
            setTimeout(startTime, 500);
            // let t = setTimeout(startTime, 500);
        }
        function checkTime(i) {
            if (i < 10) { i = "0" + i }  // add zero in front of numbers < 10
            return i;
        }

        startTime();

        var yearPercentage = document.getElementById('year-percentage');
        var progressBar = document.getElementById('year-progress-bar');

        function getDayOfTheYear() {
            var now = new Date();
            var start = new Date(now.getFullYear(), 0, 0);
            var diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
            var oneDay = 1000 * 60 * 60 * 24;
            var day = Math.floor(diff / oneDay);
            return day;
        }

        function getDaysOfAYear() {
            var today = new Date();
            var year = today.getFullYear();
            var isLeapYear = year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
            return isLeapYear ? 366 : 365;
        }

        function getYearPercentage() {
            return (getDayOfTheYear() / getDaysOfAYear()) * 100;
        }

        function render() {
            yearPercentage.innerHTML = 'Year progress: ' + getYearPercentage().toFixed(0) + '%';
            progressBar.value = getYearPercentage();
        }

        function start() {
            render();
        }
        start();

    }

    componentDidMount() {
        this.fetchUtils();
        window.jcDefaultCall();
        document.title = 'Contact';

        try {
            this.jsSetup();
        }
        catch (err) {
            // console.log(err);
        }
        this.setState({
            isLoaded: true,
        })
    }


    handleSubmit(event) {
        event.preventDefault();

        if (this.state.isSubmitting || this.state.isSent) return;

        this.setState({ isSubmitting: true });

        const formData = new FormData(event.target);
        var csrftoken = this.getCookie('csrftoken');

        fetch('https://api.jamescosmin.com/contact/', {
            method: 'POST',
            headers: {
                'X-CSRFToken': csrftoken
            },
            body: formData,
        })
            .then(response => {
                if (response.ok) {
                    this.setState({ isSent: true, isSubmitting: false });
                } else {
                    console.error('Submission failed');
                    this.setState({ isSubmitting: false });
                }
            })
            .catch(e => {
                console.error('ERROR:', e);
                this.setState({ isSubmitting: false });
            });
    }

    getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    render() {
        if (!this.state.isLoaded) {
            return (
                <Loader />
            )
        }
        else {
            return (
                <Form
                    onSubmit={this.handleSubmit.bind(this)}
                    contact_description={this.state.contact_description}
                    isSent={this.state.isSent}
                    isSubmitting={this.state.isSubmitting}
                />
            )
        }
    }
}


class Form extends React.Component {
    render() {
        let onSubmit = this.props.onSubmit;
        let contact_description = this.props.contact_description;
        let isSubmitting = this.props.isSubmitting;
        return (
            <>
                <div className="container">
                    <div className="jccard">
                        <h2>Contact</h2>

                        <div style={{ paddingBottom: "1rem", textAlign: "center" }}>
                            <h4 style={{ textTransform: "uppercase", letterSpacing: "3px", fontSize: "1rem", marginBottom: "1.5rem", color: "var(--strongorange)" }}>Representation</h4>
                            <p style={{ lineHeight: "1.8", fontSize: "1rem", marginBottom: "0" }}>
                                <strong>INFIN8 Artists & Entertainment</strong><br />
                                Anthony Leones<br />
                                CEO | Talent Manager<br />
                                <a href="mailto:anthony@infin8artists.com" className="neulink">anthony@infin8artists.com</a><br />
                                + 1 (424) 488-8813 ext 101
                            </p>
                        </div>

                        <hr className="style-two" style={{ marginBottom: "2rem", marginTop: "1rem" }} />

                        <p style={{ marginBottom: "2rem", textAlign: "center" }}>For everything else, the form below is yours.</p>

                        <form method="post" id="contact_form" onSubmit={onSubmit}>
                            <div className="form-row">
                                <div className="form-group col-md-6 mb-0">
                                    <div className="inputgroup">
                                        <span style={{ width: "100%" }}>
                                            <input type="text" name="name" placeholder="Your name" required id="id_name" />
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group col-md-6 mb-0">
                                    <div className="inputgroup">
                                        <span style={{ width: "100%" }}>
                                            <input type="email" name="email" placeholder="Your email" required
                                                id="id_email" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="inputgroup">
                                <input type="text" name="subject" placeholder="Subject" required
                                    id="id_subject" />
                            </div>
                            <div className="inputgroup">
                                {/* "If a man has a talent and cannot use it, he has failed. If he has a talent and only uses half of it, he has partly failed. If he has a talent and learns to use the whole of it, he has gloriously succeeded, and won a satisfaction and triumph few men will know." ― Thomas Wolfe */}
                                <textarea name="message" cols="40" rows="10"
                                    placeholder='Your thoughts&#10;&#10002;'></textarea>
                            </div>
                            {/* ZEN HONEYPOT: Bots see this, humans don't. */}
                            <div style={{ opacity: 0, position: "absolute", top: 0, left: 0, height: 0, width: 0, zIndex: -1, overflow: "hidden" }}>
                                <input type="text" name="address_verification" tabIndex="-1" autoComplete="off" placeholder="Address Verification" />
                            </div>
                            <div className="form-actions">
                                {!this.props.isSent ? (
                                    <div className="neubuttonbasic" style={{ position: "relative" }}>
                                        <button type="submit" name="_submit" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", zIndex: 2 }}></button>
                                        Send
                                        <i className="lab la-telegram la-lg" style={{ color: "var(--strongorange)", marginLeft: "7px" }}></i>
                                    </div>
                                ) : (
                                    <div className="zen-success-trigger">
                                        <div className="checkmark-circle">
                                            <div className="background"></div>
                                            <div className="checkmark draw"></div>
                                        </div>
                                        <p className="zen-sent-text" style={{ color: "var(--strongorange)" }}>Sent</p>
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                    <div id="clock">
                        <p className="date" id="date_count"></p>
                        <p className="time" id="time_count"></p>
                    </div>
                    <progress id="year-progress-bar" className="yrperc" value="" max="100"></progress>
                    <div style={{ textAlign: "center" }}>
                        <p id="year-percentage"></p>
                    </div>
                </div>
                <Footer />
            </>
        )
    }
}

export default Contact;
